__turbopack_context__.v({
  "root": "TagsList-module-scss-module__yGCjma__root",
});
